// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins";

// Constants
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants";
import { BREEDER_ROUTES } from "@/app/constants/breeder-routes-constants";

const DOG_GENDER = {
    DAM: "Dam",
    SIRE: "Sire",
};

export default {
    name: "AddMatingContainer",
    components: {},
    props: {
        isDamDisabled: {
            type: Boolean,
            default: false,
        },
        damDetails: {
            type: Object,
            default: null,
        },
        sireDetails: {
            type: Object,
            default: null,
        },
        matingNotesHistoryItems: {
            type: Array,
            default() {
                return [];
            },
        },
        isDisableAllFunction: {
            type: Boolean,
            default: false,
        },
    },
    directive: {},
    filters: {},
    mixins: [toastMessageMixins, dateMixins, comingSoonMixins],
    data() {
        return {
            isAPILoading: false,
            isAPISubmitLoading: false,
            isAddingSuccess: false,

            alias: "",

            matingId: null,
            matingNotes: "",
            matingNotesHistory: [],

            damList: [],
            selectedDam: null,
            damNameAndBreed: "",
            sireNameAndBreed: "",
            isDamImageLoading: false,

            sireList: [],
            selectedSire: null,
            isSireImageLoading: false,

            initialValues: {},
        };
    },
    async created() {
        this.damList = await this.getBreederDamAndSireListByGender(DOG_GENDER.DAM);
        this.sireList = await this.getBreederDamAndSireListByGender(DOG_GENDER.SIRE);

        if (this.$route.query) {
            this.matingId = this.$route.query.id;
        }

        this.selectedDam = this.damDetails;
        this.selectedSire  = this.sireDetails

        if (this.sireDetails && this.sireDetails.id) {
            const initialSelectedSire= this.sireList.find((sire) => parseFloat(sire.id) === parseFloat(this.sireDetails.id));

            const birthdate = this.sireDetails.birthdate ? this.formatDate(new Date(this.sireDetails.birthdate)) : this.formatDate(new Date(initialSelectedSire.birthdate));

            this.selectedDam = {
                ...initialSelectedSire,
                ...this.sireDetails,
                birthdate,
            };
            this.$emit("onSireSelect", { isInitial: true, selectedSire: this.selectedSire });
            this.sireNameAndBreed = `${this.sireDetails.dogName} - ${this.sireDetails.breedName}`;
        }

        if (this.damDetails && this.damDetails.id) {
            const initialSelectedDam = this.damList.find((dam) => parseFloat(dam.id) === parseFloat(this.damDetails.id));

            const birthdate = this.damDetails.birthdate ? this.formatDate(new Date(this.damDetails.birthdate)) : this.formatDate(new Date(initialSelectedDam.birthdate));

            this.selectedDam = {
                ...initialSelectedDam,
                ...this.damDetails,
                birthdate,
            };
            this.$emit("onDamSelect", { isInitial: true, selectedDam: this.selectedDam });
            this.damNameAndBreed = `${this.damDetails.dogName} - ${this.damDetails.breedName}`;
        }

        this.selectedSire = this.sireDetails;
        this.matingNotesHistory = this.matingNotesHistoryItems;

        if (this.matingNotesHistory && this.matingNotesHistory.length > 0) {
            this.matingNotesHistory = this.matingNotesHistory.filter((noteObj) => noteObj.note !== "");
            this.matingNotes = this.matingNotesHistory[0].note;
        }
    },
    methods: {
        async onSubmitDetails() {
            try {
                this.isAPISubmitLoading = true;

                if (!this.selectedDam && !this.selectedSire) {
                    await this.$swal({
                        text: "Please select either Dam or Sire.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return;
                }

                const matingDetails = {
                    damId: this.selectedDam ? this.selectedDam.id : null,
                    sireId: this.selectedSire ? this.selectedSire.id : null,
                    note: this.matingNotes,
                };

                const response = await breedingManagementService.addDamAndSireMatingDetails(matingDetails);

                const { SUCCESS_ADD_MATING, ERROR_ADD_MATING } = this.toastMessages.mating();

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_MATING);
                    this.isAddingSuccess = true;
                    this.$router.push(BREEDER_ROUTES.MATING_LIST);
                } else {
                    this.showAPIErrorToast(ERROR_ADD_MATING, response);
                }
            } catch (err) {
                this.isAddingSuccess = false;
                this.showGenericErrorToast();
            } finally {
                this.isAPISubmitLoading = false;
            }
        },
        async getBreederDamAndSireListByGender(gender) {
            if (!gender) {
                return;
            }

            try {
                this.isAPILoading = true;
                const damSireListResponse = await breedingManagementService.getBreederDamAndSireListByGender(gender);

                if (damSireListResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: listData } = damSireListResponse;

                    // customLabel to be used in the v-select "label" for searching by breedName and dogName combined
                    const formattedData = listData.map((data) => {
                        const { breedName, dogName } = data;

                        if (breedName && dogName) {
                            return {
                                ...data,
                                customLabel: `${breedName} - ${dogName}`,
                            };
                        } else {
                            return { ...data, customLabel: `${breedName}` };
                        }
                    });

                    return formattedData;
                } else {
                    const { ERROR_GET_DAM_SIRE_LIST } = this.toastMessages.mating();
                    this.showAPIErrorToast(ERROR_GET_DAM_SIRE_LIST, damSireListResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        onDamSelect(selectedItem) {
            if (!selectedItem) {
                this.isDamImageLoading = false;
                this.$emit("onDamSelect", { isInitial: false, selectedDam: null });
                return;
            }

            if (selectedItem.imageUrl) {
                this.isDamImageLoading = true;
            } else {
                this.isDamImageLoading = false;
            }

            this.selectedDam = {
                ...selectedItem,
                birthdate: this.formatDateTime(new Date(selectedItem.birthdate), "dd-MMM-yyyy"),
            };
            this.$emit("onDamSelect", { isInitial: false, selectedDam: this.selectedDam });
        },
        onSireSelect(selectedItem) {
            if (!selectedItem) {
                this.isSireImageLoading = false;
                this.$emit("onSireSelect", { isInitial: false, selectedSire: null });
                return;
            }

            if (selectedItem.imageUrl) {
                this.isSireImageLoading = true;
            } else {
                this.isSireImageLoading = false;
            }

            this.selectedSire = {
                ...selectedItem,
                birthdate: this.formatDateTime(new Date(selectedItem.birthdate), "dd-MMM-yyyy"),
            };
            this.$emit("onSireSelect", { isInitial: false, selectedSire: this.selectedSire });
        },
        handleLoadingImage(gender) {
            if (DOG_GENDER.DAM === gender) {
                this.isDamImageLoading = false;
            }

            if (DOG_GENDER.SIRE === gender) {
                this.isSireImageLoading = false;
            }
        },
        redirectToOvulation(e) {
            e.preventDefault();
            this.showHomeComingSoonAlert();
        },
        redirectToMatingList() {
            this.$router.push(`${BREEDER_ROUTES.MATING_LIST}`);
        },
        redirectToAddNewMating() {
            this.$router.push(`${BREEDER_ROUTES.ADD_MATING}?dam=${this.damDetails.id}&from=ovulation-mating`);
        },
        handleMatingNoteChange() {
            this.$emit("onMatingNoteChange", this.matingNotes);
        },
    },
};
